import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const PlayTick = ({trackStep, stepWidth, length}) => { 
    let _step = trackStep % length;
    let percentage = 100 * _step / length
    return (
        <div style={{width: percentage + '%'}} className="play-tick">
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      trackStep: props.sequencerEngine.trackStep
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayTick);
